export default __webpack_public_path__ + "static/media/mars15.13c66151.gif";